// Inline placeholder — avoids 404 on missing /file_fail.jpg in public/
export const DOCUMENT_ERROR_SOURCE =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1"/>'
  );
export const DOCUMENT_PENDING_SOURCE = '#';
